import { render, staticRenderFns } from "./MyOpenContacts.vue?vue&type=template&id=0870d6d1"
import script from "./MyOpenContacts.vue?vue&type=script&lang=js"
export * from "./MyOpenContacts.vue?vue&type=script&lang=js"
import style0 from "./MyOpenContacts.vue?vue&type=style&index=0&id=0870d6d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports